import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Navbar from "@/components/Navbar";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Categories from "@/pages/Categories";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Terms from "./components/Terms";
function App() {
  return (
    <ThemeProvider>
      <div className="App bg-white dark:bg-[#0B1120] transition-colors">
        <BrowserRouter>
          <Navbar />
          <ScrollToTop />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/:slug" element={<ProductDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>

          {/* Floating Button */}
          <WhatsAppFloatingButton />
        </BrowserRouter>

        <Toaster richColors position="top-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;